export type CdaConsent = {
  email: boolean
  sms: boolean
  trackingOpen: boolean
  partenaires: boolean
  whatsapp: boolean
}

export const defaultCdaConsent = (): CdaConsent => ({
  email: false,
  sms: false,
  trackingOpen: false,
  partenaires: false,
  whatsapp: false,
})
